module.exports = __webpack_public_path__ + "files/7dee8c450a73b0fcf22d2ae1c1547af9.png";